<template>
  <vz-collapse collapsible class="mt-20" without-border>
    <template #header>
      <div class="text-h1 color-lower my-auto mr-auto flex-inline">
        Необходимые документы
      </div>
    </template>
    <template #content>
      <div class="vz-personal-order-blocks">
        <div>
          <div class="text-h1 vz-special-requirement-card-title">
            Для отправления
          </div>
          <vz-collapse-info class="vz-order-document-title pl-10">
            <template #header>
              Физическое лицо
            </template>
            <div class="flex flex-column pl-10">
              <div v-for="text of requiredDocuments.dispatch.individual" v-html="text" />
            </div>
          </vz-collapse-info>
          <vz-collapse-info class="vz-order-document-title pl-10">
            <template #header>
              Юридическое лицо
            </template>
            <div class="flex flex-column pl-10">
              <div v-for="text of requiredDocuments.dispatch.corporation" v-html="text" />
            </div>
          </vz-collapse-info>
        </div>
        <div>
          <div class="text-h1 vz-special-requirement-card-title">
            Для получения
          </div>
          <vz-collapse-info class="vz-order-document-title pl-10">
            <template #header>
              Физическое лицо
            </template>
            <div class="flex flex-column pl-10">
              <div v-for="text of requiredDocuments.destination.individual" v-html="text" />
            </div>
          </vz-collapse-info>
          <vz-collapse-info class="vz-order-document-title pl-10">
            <template #header>
              Юридическое лицо
            </template>
            <div class="flex flex-column pl-10">
              <div v-for="text of requiredDocuments.destination.corporation" v-html="text" /></div>
          </vz-collapse-info>
        </div>
      </div>
    </template>
  </vz-collapse>
</template>

<script setup lang="ts">
import VzCollapse from '~/components/ui-kit/vz-collapse.vue';
import VzCollapseInfo from '~/components/ui-kit/vz-collapse-info.vue';
const requiredDocuments = (await import('~/common/objects/requiredDocuments')).default;
</script>

<style lang="scss" scoped>
.vz-order-document-title {
  margin: 10px 0;
  border-bottom: 1px solid $border-gray;
}
</style>
